export class ItemNoDto {
    id: string;
    itemNo?: string;
    poNumber?:string
    poLine?:string
    shipToAddress?:string
    constructor(
      id: string,
      itemNo?: string,
     poNumber?:string,
    poLine?:string,
    shipToAddress?:string,



    ) {
      this.id = id,
        this.itemNo = itemNo;
        this.poNumber = poNumber;
        this.poLine = poLine;
        this.shipToAddress=shipToAddress
    }
  }